'use strict';

import {dataMember, required} from 'santee-dcts';

export class SponsorStudy {

    @dataMember()
    @required()
    public protocolId: number;

    @dataMember()
    @required()
    public protocolName: string;

    @dataMember()
    @required()
    public sponsorName: string;

    @dataMember()
    @required({ nullable: true })
    public isFavorite: boolean;

    @dataMember()
    @required()
    public numberOfSites: number;

    @dataMember()
    @required()
    public numberOfSubjects: number;

    public ctProtocolId: number;
}
